import { SlideGallery } from "@/features/work/SlideGallery";

const patents = {
  wo2015004645: {
    pages: 9,
    title: "Business networking, WO2015004645A2",
  },
  us20150234585: {
    pages: 9,
    title: "Innovation management, US20150234585",
  },
} as const;

export function PatentPages({ id }: { id: keyof typeof patents }) {
  const patent = patents[id];
  const slides = Array.from({ length: patent.pages }, (_, index) => {
    const page = index + 1;
    return {
      src: `/images/patents/${id}/page-${page}.png`,
      alt: `${patent.title}, page ${page} of ${patent.pages}`,
      caption: `Page ${page} of ${patent.pages}`,
      width: 935,
      height: 1210,
    };
  });
  return <SlideGallery slides={slides} tone="paper" />;
}
